/** Базовый URL сервера для склейки с путём картинки при отображении */
export const IMAGE_BASE_URL = "https://florapoint.su";

/**
 * Для отображения: если пришёл путь вида /images/..., возвращает полный URL.
 * Если уже полный URL — возвращает как есть.
 */
export function getImageDisplayUrl(pathOrUrl: string): string {
  if (!pathOrUrl) return pathOrUrl;
  if (pathOrUrl.startsWith("http://") || pathOrUrl.startsWith("https://")) {
    return pathOrUrl;
  }
  const path = pathOrUrl.startsWith("/") ? pathOrUrl : `/${pathOrUrl}`;
  return `${IMAGE_BASE_URL}${path}`;
}

/**
 * Для отправки на бэк: оставляет только путь (/images/...), убирает базовый URL при наличии.
 */
export function toImagePath(urlOrPath: string): string {
  if (!urlOrPath) return urlOrPath;
  try {
    if (urlOrPath.startsWith("http://") || urlOrPath.startsWith("https://")) {
      const u = new URL(urlOrPath);
      return u.pathname;
    }
  } catch {
    // не URL — считаем уже путём
  }
  return urlOrPath.startsWith("/") ? urlOrPath : `/${urlOrPath}`;
}
